import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import Button from '@mui/material/Button'

import { QuizDispatchContext, QuizStoreContext } from '../contexts/quizContext'

import { questions_list } from '../data/questions'

import ImageQuestion from '../components/ImageQuestion/ImageQuestion'
import ProgressBar from '../components/ProgressBar/ProgressBar'
import TextQuestion from '../components/TextQuestion'
import ScrollToTop from '../utils/ScrollToTop'
import { T } from '../utils/Typography'
import BottomContainer from '../components/BottomContainer/BottomContainer'
import SliderQuestion from '../components/SliderQuestion/SliderQuestion'
import { MAX_SCREEN_WIDTH } from '../utils/constants'
import useMediaQuery from '@mui/material/useMediaQuery'

const QuizRerenderProtector: React.FC = () => {
  const { quizIndex } = React.useContext(QuizStoreContext)

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [quizIndex])

  // console.log('quiz protector rerender', quizIndex)
  return <Quiz quizIndex={quizIndex} />
}

type QuizProps = {
  quizIndex: number
}

const Quiz: React.FC<QuizProps> = React.memo(({ quizIndex }) => {
  const reduceQuizData = React.useContext(QuizDispatchContext)
  // console.log('Quiz reloaded')
  const history = useHistory()

  // https://stackoverflow.com/questions/61939358/how-to-intercept-back-button-in-a-react-spa-using-function-components-and-react
  React.useEffect(() => {
    // console.log('history created')
    const listener = history.listen((newloc, action) => {
      if (action === 'POP') {
        // const matches = forwardStack.filter(f => f.key === newloc.key);
        // if (matches.length > 0){
        // console.log(`going forward! ${JSON.stringify(matches)}`)
        // reduceQuizIndex({ type:'set', payload: matches[0].index})
        // } else {
        //go back
        // setForwardStack(forwardStack => [...forwardStack, {key: newloc.key, index: quizIndex}])
        reduceQuizData({ type: 'back_quiz_index' })
        // }
        // history.goBack()
        //       // history.go(-1)
        //       // set state back one to render previous "page" (state)
      } else if (action === 'PUSH') {
        // reduceQuizIndex()
      }
      // console.log('history listener')
      // console.log(newloc)
      // console.log(action)
    })
    return listener
  }, [history, reduceQuizData])

  const question = questions_list[quizIndex]

  const _onClick = (
    direction: 'increment_quiz_index' | 'decrement_quiz_index',
  ) => {
    reduceQuizData({ type: direction })
  }

  const wideScreen = useMediaQuery('(min-width:1050px')

  return (
    <div className='Quiz-container' style={{ maxWidth: MAX_SCREEN_WIDTH }}>
      <ScrollToTop />
      <div style={{ maxWidth: '700px', padding: 20 }}>
        <T
          variant='h1'
          style={{
            fontFamily: 'Viva-Beautiful',
            ...(!wideScreen ? { fontSize: 66 } : {}),
          }}>
          <b>Find Your Podcast Style</b>
        </T>
        <br />
        <ProgressBar
          current={quizIndex + 1}
          total={questions_list.length}
          reduceQuizData={reduceQuizData}
        />
      </div>
      {question.type === 'slider' ? (
        <SliderQuestion
          currentQuizIndex={quizIndex}
          reduceQuizData={reduceQuizData}
          options={question.options}
          questionText={question.question_text}
        />
      ) : question.type === 'image' ? (
        <ImageQuestion
          currentQuizIndex={quizIndex}
          reduceQuizData={reduceQuizData}
          options={question.options}
          questionText={question.question_text}
          subText={question.subtext}
          preText={question.pretext}
        />
      ) : (
        <TextQuestion
          currentQuizIndex={quizIndex}
          questionText={question.question_text}
          options={question.options}
          maxSelections={question.max_selections}
          minSelections={question.min_selections}
        />
      )}
      <BottomContainer
        leftButton={
          quizIndex > 0 ? (
            <Button
              className='App-button'
              onClick={() => _onClick('decrement_quiz_index')}>
              PREV
            </Button>
          ) : (
            <br />
          )
        }
        rightButton={
          quizIndex < questions_list.length - 1 ? (
            <Button
              className='App-button'
              onClick={() => _onClick('increment_quiz_index')}>
              NEXT
            </Button>
          ) : (
            <Button
              className='App-button'
              component={Link}
              to='/almost-finished/'>
              SUBMIT
            </Button>
          )
        }
      />
    </div>
  )
})

export default QuizRerenderProtector
